export default __webpack_public_path__ + "static/media/search-b.de034990.png";